<div class="order-timeline">
  <div class="row">
    <div class="col-md-3">
      <div class="order-title margin-10-12">Order timeline</div>
    </div>
    <div style="align-items: center; text-align: center;" class="col-md-3 margin-10-12">
      <span class="display-inline-block font-size-14 font-weight-600">Service Type :</span>
      <span class="font-size-14 font-weight-600" style="text-transform: capitalize; padding-left: 1%">
        {{serviceType}} ({{serviceName}})
      </span>
    </div>
    <div style="align-items: center; text-align: center;" class="col-md-3 margin-10-12">
      <span class="display-inline-block font-size-14 font-weight-600">City :</span>
      <span class="font-size-14 font-weight-600" style="text-transform: capitalize; padding-left: 1%">
        {{city}}
      </span>
    </div>
    <div class="col-md-2 view" *ngIf="dataFetched">
      <span class="view-details" (click)="toggleStatus()">{{viewDetails}}</span>
      <i class="material-icons arrow-up" (click)="toggleStatus()" *ngIf="viewMore">arrow_drop_up</i>
      <i class="material-icons arrow-up" (click)="toggleStatus()" *ngIf="!viewMore">arrow_drop_down</i>
    </div>
  </div>

  <div class="line"></div>

  <div *ngIf="dataFetched">
    <div class="row" [hidden]="!showTimeline">
      <div class="col-md-12 order-timeline-wrapper">
          <app-order-status [statusDetails]="orderTimeLine" [FNDcase]="FNDCase" [statusMap]="statusMap"></app-order-status>
      </div>
    </div>
    <div class="line" *ngIf="showTimeline"></div>

    <div class="row padding-bottom-18 align-items-center">
      <div class="col-md-3">
        <span class="display-inline-block font-size-14 font-weight-600">Order tags : 
          <span [ngStyle]="{'color' : orderTags.indexOf('Nil') === -1 ? '#ffffff' : 'black'}" 
            [ngClass]="{'order-tags' : orderTags.indexOf('Nil') === -1}" *ngFor="let tag of orderTags">{{tag}}</span>
        </span><br>
        <span class="display-inline-block margin-top-8 font-size-14 font-weight-600">Fraud tags :
          <span [ngStyle]="{'color' : fraudTags.indexOf('Nil') === -1 ? '#ffffff' : 'black'}" 
            [ngClass]="{'fraud-tags' : fraudTags.indexOf('Nil') === -1}" *ngFor="let tag of fraudTags">{{tag}}</span>
        </span><br>
      </div>

      <div *ngIf="currentStatus" style="display: flex; align-items: center;">
        <span class="font-size-13 font-weight-600">Status : </span>
        <div class="status-indicator display-inline-block background-color-cd1f1e"
        [ngStyle]="{'background-color': statusRed.indexOf(currentStatus) === -1 ? 
                    '#5fba00' : '#cd1f1e'}" class="pulse"></div>
        <span class="font-size-13 font-weight-600"
          [ngStyle]="{'color': statusRed.indexOf(currentStatus) === -1 ? 
                      '#5fba00' : '#cd1f1e'}">{{currentStatus}}</span>
        <i class="material-icons edit-icon font-size-16 cursor-pointer"
          (click)="changeStatus(currentStatus)" *ngIf="this.allowStatusChangeFrom[currentStatus]">create</i>

      </div>

      <div *ngIf="primaryOrderId && primaryOrderId.length > 0" class="d-flex align-items-center mr-3">
        <span class="mr-2">Parent Order Id: </span>
        <span class="font-size-13 font-weight-600 cursor-pointer" style="text-transform: capitalize; color: blue"
              (click)="navigateToReturnOrderId(primaryOrderId)">
          {{primaryOrderId}}
        </span>
      </div>
      <div *ngIf="returnOrderId && returnOrderId.length > 0" class="col-md-2" style="display: flex; align-items: center;">
        <span>RTO Order Id: </span>
        <span class="font-size-13 font-weight-600 cursor-pointer"
              style="text-transform: capitalize; color: blue"
              (click)="navigateToPrimaryOrderId(returnOrderId)">
          {{returnOrderId}}
        </span>
      </div>
      <div *ngIf="microCorridor" class="col-md-2" style="display: flex; align-items: center;">
        <span>Micro Corridor: </span>
        <span class="font-size-13 font-weight-600" style="text-transform: capitalize; padding-left: 1%">
          {{microCorridor}}
        </span>
      </div>
      <div *ngIf="earningModel === 'minimum_guarantee'" class="timeline-mg-center">
        <div class="mg-order-nudge-inner">
          <div class="mg-order-nudge-title">MG ORDER</div>
          <div class="mg-order-nudge-yes"><span class="mg-order-nudge-bullet">&#8226;</span> Yes</div>
        </div>
      </div>
      <div class="col time-line-button">
            <button *ngIf= "isDropOrderEnabled" class="drop-order font-size-13 font-weight-600 margin-right-12" (click)="partialDropOrder()"
              >Drop Order
            </button>
            <button class="initiate-rto font-size-13 font-weight-600 margin-right-12" (click)="initiateRTO()"
                    [ngStyle]="{'background-color': isRTOAllowed ? '#467fcf' : ' #ffffff',
                            'color': isRTOAllowed ? '#ffffff' : '#a0a0a0',
                            'border': isRTOAllowed ? '1px solid #467fcf': 'solid 1px #a0a0a0'}">Initiate RTO
            </button>
            <button class="activity-log color-cd1f1e font-size-13 font-weight-600" (click)="getActivityLog()"
              [ngStyle]="{'color': '#343A40','border': '1px solid #343A40'}">Activity Log
            </button>
        <div class="d-flex align-items-center justify-content-end">
        <button class="abort color-cd1f1e font-size-13 font-weight-600 margin-right-12" (click)="abort()"
            [ngStyle]="{'color': abortRide ? '#343A40' : '#a0a0a0',
            'border': abortRide ? '1px solid #343A40': 'solid 1px #a0a0a0'}">Abort
        </button>
            <button class="abort color-cd1f1e font-size-13 font-weight-600 margin-right-12" (click)="cancel()"
            [ngStyle]="{'color': cancelRide ? '#343A40' : '#a0a0a0',
            'border': cancelRide ? '1px solid #343A40': 'solid 1px #a0a0a0'}">Cancel
            </button>
          <button class="reassign font-size-13 font-weight-600" (click)="reAssignCaptain()"
            [ngStyle]="{'background-color': isReassignable ? '#467fcf' : ' #ffffff',
                        'color': isReassignable ? '#ffffff' : '#a0a0a0',
                        'border': isReassignable ? '1px solid #467fcf': 'solid 1px #a0a0a0'}">Re-assign
          </button>
        </div>
      </div>
    </div>

  <div class="line"></div>

  <div class="row" *ngIf="bookForSomeoneElse && (bookForSomeoneElse.customer || bookForSomeoneElse.identifiedBy)">
    <div class="col-md-12">
      <div class="d-flex align-items-center px-3 py-3" style="background-color: #f8f9fa; border-radius: 8px; margin: 0.5rem 0;">
        <div class="d-flex align-items-center mr-4" style="min-width: 200px;">
          <i class="material-icons mr-2" style="color: #467fcf; font-size: 18px;">person</i>
          <span class="font-size-14 font-weight-600" style="color: #467fcf;">Customer Details (BFSE)</span>
        </div>
        
        <div class="d-flex justify-content-between align-items-center" style="flex: 1;">
          <div class="d-flex flex-column align-items-center" style="flex: 1;">
            <span class="font-size-12 font-weight-500" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px;">Name</span>
            <span class="font-size-14 font-weight-600 mt-1" style="color: #343a40;">{{bookForSomeoneElse?.customer?.name || 'N/A'}}</span>
          </div>
          
          <div class="d-flex flex-column align-items-center" style="flex: 1;">
            <span class="font-size-12 font-weight-500" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px;">Phone Number</span>
            <span class="font-size-14 font-weight-600 mt-1" style="color: #343a40;">{{bookForSomeoneElse?.customer?.phoneNumber || 'N/A'}}</span>
          </div>
          
          <div class="d-flex flex-column align-items-center" style="flex: 1;">
            <span class="font-size-12 font-weight-500" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px;">Identified By</span>
            <span class="font-size-14 font-weight-600 mt-1" style="color: #343a40; text-transform: capitalize;">{{bookForSomeoneElse?.identifiedBy || 'N/A'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Hail and Order Type Table -->
  <div class="row">
    <div class="col-md-12">
      <div class="px-2 py-2" style="background-color: #f8f9fa; border-radius: 8px; margin: 0.5rem 0 1rem 0;">
        <table class="table table-borderless mb-0">
          <thead>
            <tr>
              <th class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">Hail</th>
              <th class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">Order Type</th>
              <th class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">Captain Switch</th>
              <th class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">Corporate</th>
              <th *ngIf="bundleDetails" class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">Bundle</th>
              <th *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL'" class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">Payment Status</th>
              <th *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL'" class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">Payment Mode</th>
              <th *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL'" class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">HOP IN</th>
              <th *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL'" class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">HOP OUT</th>
              <th *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL' && tripStatus" class="font-size-12 font-weight-600 text-center" style="color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">Trip Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="font-size-14 font-weight-600 text-center" style="color: #343a40; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{hailTableView || 'N/A'}}
              </td>
              <td class="font-size-14 font-weight-600 text-center" style="color: #343a40; text-transform: capitalize; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{orderType || 'N/A'}}
              </td>
              <td class="font-size-14 font-weight-600 text-center" style="color: #343a40; text-transform: capitalize; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{captainSwitchTableView || 'N/A'}}
              </td>
              <td class="font-size-14 font-weight-600 text-center" style="color: #343a40; text-transform: capitalize; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{isCorporateOrder || 'N/A'}}
              </td>
              <td *ngIf="bundleDetails" class="font-size-14 font-weight-600 text-center" style="color: #343a40; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                <div style="word-break: break-word;">{{ bundleDetails.id }}</div>
                <div class="mt-1">{{ bundleDetails.details }}</div>
              </td>
              <td *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL'" class="font-size-14 font-weight-600 text-center" style="color: #343a40; text-transform: capitalize; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{paymentStatus || 'N/A'}}
              </td>
              <td *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL'" class="font-size-14 font-weight-600 text-center" style="color: #343a40; text-transform: capitalize; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{paymentMode || 'N/A'}}
              </td>
              <td *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL'" class="font-size-14 font-weight-600 text-center" style="color: #343a40; text-transform: capitalize; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{hopIn || 'No'}}
              </td>
              <td *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL'" class="font-size-14 font-weight-600 text-center" style="color: #343a40; text-transform: capitalize; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{hopOut || 'No'}}
              </td>
              <td *ngIf="poolInfo && poolInfo.type === 'MPMD_CORPORATE_POOL' && tripStatus" class="font-size-14 font-weight-600 text-center" style="color: #343a40; text-transform: capitalize; border: none; padding: 0rem 1rem; margin-bottom: 0.5rem;">
                {{tripStatus}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  </div>

  <div *ngIf="!dataFetched" class="noDataWrapper">
    <span>No data found ¯\_(ツ)_/¯</span>
  </div>

</div>